import { gql, TypedDocumentNode } from "@apollo/client";

import {
  CreateScenarioMutation,
  CreateScenarioMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { getShortScenariosQuery } from "src/graphql/anti-fraud/queries/scenarios/GetShortScenariosQuery.ts";
import { usePerformMutation } from "src/graphql/utils";

export const createScenarioMutation = gql(/* GraphQL */ `
  mutation createScenario(
    $code: String!
    $name: String!
    $description: String!
    $rules: [RuleInput!]!
    $threshold: Float!
    $caseTypeCode: String!
  ) {
    createScenario(
      input: {
        code: $code
        name: $name
        description: $description
        rules: $rules
        threshold: $threshold
        caseTypeCode: $caseTypeCode
      }
    )
  }
`) as TypedDocumentNode<CreateScenarioMutation, CreateScenarioMutationVariables>;

/* Hooks */

type UseCreateScenarioMutationProps = {
  onSuccess: (data: CreateScenarioMutation | null | undefined) => void;
};

export const useCreateScenarioMutation = ({ onSuccess }: UseCreateScenarioMutationProps) => {
  return usePerformMutation(createScenarioMutation, {
    onSuccess,
    mutationOption: { refetchQueries: [getShortScenariosQuery], awaitRefetchQueries: true },
  });
};
